// extracted by mini-css-extract-plugin
export default {"tutor_img":"TutorialContent_tutor_img__XIeqG","tutor_con":"TutorialContent_tutor_con__Cmd7D","tutor_img_con":"TutorialContent_tutor_img_con__3keMT"};